import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabsNextElement } from './OneUxTabsNextElement.js';
export const register = getRegisterFunction(OneUxTabsNextElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tabs-next': OneUxTabsNextElement;
    "tabs-next-8e567e2bd9a36f3b3e64ac591782d6c4": OneUxTabsNextElement;
  }
}